/**
 * External dependencies
 */
import { createContext } from 'react';

const SettingsContext = createContext<SettingsContextType | null>(null);

export default SettingsContext;
